import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Ghanaian Ghana Card validator following Single Responsibility Principle
 */
export class GhValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Ghanaian Ghana Card',
      pattern: /^GHA-\d{9}-\d$/,
      length: 15
    });
  }

  validateFormat(id) {
    const upperCaseId = id.toUpperCase();
    
    // Check length
    const lengthValidation = this.validateLength(upperCaseId, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      upperCaseId,
      this.config.pattern,
      'Ghana Card format must be GHA-XXXXXXXXX-X'
    );
  }

  validateChecksum(id) {
    const upperCaseId = id.toUpperCase();
    const digits = upperCaseId.replace(/[^0-9]/g, '');
    
    // Basic Luhn check on the numeric part
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 2; i >= 0; i--) {
      let n = parseInt(digits[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(digits[digits.length - 1]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid Ghana Card checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid Ghana Card');
  }
}